import { definitionsSelector } from '@lobby/store/selectors/config';
import { socketParamsSelector } from '@lobby/store/selectors/user';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import {
  switchMap,
  catchError,
  takeUntil,
  mergeMap,
  map,
  skipUntil,
  filter,
  take,
  finalize,
} from 'rxjs/operators';

import { BLOCKED_PLAYER, INITIAL_DATA } from '@ezugi/constants/gameSocketMessages';
import { DEFAULT_LOBBY_WS_RETRY } from '@ezugi/lobby-core/constants/socket';
import { createLobbyWebSocket } from '@ezugi/lobby-core/socket/createLobbyWebSocket';
import { rewriteWsUrlForDevProxy } from '@ezugi/utils/devProxy';

import { socket } from '../../socket';
import handleErrors from './handleErrors';
import { handleSocketMessage } from './handleSocketMessage';

const updateStore = ({ socketMessage, state }) => handleErrors(socketMessage)
  || handleSocketMessage(socketMessage, state)
  || EMPTY;

const socketEpic = (action$, state$) => action$.pipe(
  ofType(socket.request),
  switchMap(() => {
    const url = rewriteWsUrlForDevProxy(definitionsSelector(state$.value)?.SERVER_URL_LOBBY);

    const params = socketParamsSelector(state$.value);

    const cancellation$ = action$.pipe(
      ofType(socket.request, socket.failure, socket.close)
    );

    const handle = createLobbyWebSocket({
      url,
      handshake: params,
      retry: DEFAULT_LOBBY_WS_RETRY,
    });

    const sendSub = action$
      .pipe(
        ofType(socket.send),
        map((action) => action.payload),
        takeUntil(cancellation$)
      )
      .subscribe((payload) => {
        handle.send(payload);
      });

    const closeSub = action$
      .pipe(ofType(socket.close), takeUntil(cancellation$))
      .subscribe(() => {
        handle.close();
      });

    return handle.messages$.pipe(
      skipUntil(
        handle.messages$.pipe(
          filter((msg) => [ INITIAL_DATA, BLOCKED_PLAYER ].includes(msg?.MessageType)),
          take(1)
        )
      ),
      mergeMap((socketMessage) => updateStore({ socketMessage, state: state$.value })),
      takeUntil(cancellation$),
      finalize(() => {
        sendSub.unsubscribe();
        closeSub.unsubscribe();
        handle.close();
      })
    );
  }),
  catchError((error) => of(socket.failure(error.message)))
);

export default socketEpic;
